import React, { useEffect, useState } from "react";
import CustomTable from "../components/ListPageComponent";
import Pagelayout from "../components/Pagelayout";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setStatusShowOption } from "../../../filter/filterSlice";
import { getListOfSalaryDisbursement } from "../parollAPIs";
import {
  extractValues,
  formatDateTime,
  formatDateTimeN,
  toSystemDate,
} from "../../../../util/utilityFunctions";

const SalaryDisbursement = () => {
  const dispatch = useDispatch();
  localStorage.removeItem("singleViewId");
  const { paginationData, searchInput, filterData } = useSelector(
    (state) => state.payrollSlice
  );

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);

  // Example usage:
  const headers = [
    { key: "name", label: "Name" },
    { key: "accountingDate", label: "Accounting Date" },
    { key: "paymentMethod", label: "Payment Method" },
    { key: "paymentType", label: "Payment Type" },
    { key: "status", label: "Status" },
  ];

  // const data = [
  //   {
  //     name: "EMp12 - VAISHAK",
  //     accountingDate: "24/08/2023",
  //     paymentMethod: "Cheque",
  //     paymentType: "Salary",
  //     status: "Draft",
  //   },
  //   {
  //     name: "EMp12 - VAISHAK",
  //     accountingDate: "24/08/2023",
  //     paymentMethod: "Cheque",
  //     paymentType: "Salary",
  //     status: "Post",
  //   },
  //   {
  //     name: "EMp13 - JAY",
  //     accountingDate: "24/08/2023",
  //     paymentMethod: "Bank Transfer",
  //     paymentType: "Bonus",
  //     status: "Draft",
  //   },
  // ];

  // Only show specific columns
  const visibleColumns = [
    "name",
    "accountingDate",
    "paymentMethod",
    "paymentType",
    "status",
  ];
  const [isGridView, setIsGridView] = useState(false);
  const navigate = useNavigate();

  const handleRowClick = (rowData) => {
    navigate("create", { state: { _id: rowData?._id } });
    localStorage.setItem("singleViewId", rowData?._id);
  };
  const handleCreateBtn = () => {
    // console.log("Create button clicked");
    navigate("create");
  };

  // ----
  useEffect(() => {
    dispatch(setStatusShowOption(["DRAFT", "POSTED"]));

    if (filterData) {
      setLoading(true);
      getListOfSalaryDisbursement({
        page: paginationData?.currentPage,
        limit: 10,
        branchId: filterData.brach,
        paymentMethod: extractValues(filterData?.payment || []),
        status: extractValues(filterData?.status || []),
        paymentType: extractValues(filterData.paymentType || []),
        fromDate: filterData?.date.fromDate,
        toDate: filterData?.date.toDate,
        search: searchInput,
        successCallback: (response) => {
          console.log(response);
          setData(
            response.list.map((r) => ({
              ...r,
              accountingDate: formatDateTime(r?.accountingDate),
            }))
          );
        },
        errorCallback: (error) => {
          console.error(error);
          setData([]);
        },
      });
    }
  }, [
    searchInput,
    paginationData?.currentPage,
    filterData?.employee,
    filterData?.branch,
    filterData?.date,
    filterData?.payment,
    filterData?.status,
    filterData?.paymentType,
  ]);

  return (
    <Pagelayout
      pageName={"Salary Disbursement"}
      headerLayout={1}
      handleCreateBtn={handleCreateBtn}
      filterOptions={["date", "branch", "status", "payment", "paymentType"]}
      pagination={paginationData.totalPages > 1}
    >
      <CustomTable
        headers={headers}
        data={data}
        visibleColumns={visibleColumns}
        onRowClick={handleRowClick}
        loading={false}
      />
    </Pagelayout>
  );
};

export default SalaryDisbursement;
